import { $, $$ } from './shortcuts';

function getTriggers(key) {
  return $$(`[data-trigger='${key}']`);
}

function isPreselected(domNode, key) {
  return domNode.getAttribute('data-trigger-preselected') === key;
}

function getPreselectedTrigger(key) {
  return $(`[data-trigger='${key}'][data-trigger-preselected='${key}']`);
}

export { getTriggers, isPreselected, getPreselectedTrigger };
